import axios from 'axios';
import { installOfflineSync } from './offlineQueue';

// Pick the API URL at runtime so the same JS bundle works for both:
//   • http://192.168.0.11:3000  → http://192.168.0.11:8000/api  (iPhone / http clients)
//   • https://192.168.0.11:3443 → https://192.168.0.11:8443/api (Chrome / Safari HTTPS)
let apiBaseURL = process.env.REACT_APP_API_URL;

// Dynamically upgrade API endpoint to HTTPS and the 8443 proxy port if the browser is on HTTPS
// This prevents mixed-content Network Errors without requiring a full Node / React bundle restart.
if (window.location.protocol === 'https:') {
    const overrideEnv = process.env.REACT_APP_API_URL_HTTPS;
    if (overrideEnv) {
        apiBaseURL = overrideEnv;
    } else if (apiBaseURL?.includes('http://')) {
        apiBaseURL = apiBaseURL.replace('http://', 'https://').replace(':8000', ':8443');
    }
}
const API = axios.create({
    baseURL: apiBaseURL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

API.interceptors.request.use(config => {
    const token = localStorage.getItem("connect_token");
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    const sessionKey = localStorage.getItem("audio_room_session_key");
    if (sessionKey) {
        config.headers['X-Session-Key'] = sessionKey;
    }
    return config;
});

// Install offline action queue — replays mutations on reconnect
installOfflineSync(API);

export default API;